import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  ref,
  watch,
  withDefaults,
} from "vue";
import type { IFieldValue, IFormRule } from "@/components/form/types";

// props
interface Props {
  message?: string;
  rules?: IFormRule[];
  lazy?: boolean;
  modelValue?: IFieldValue;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    message: null,
    rules: null,
    lazy: { type: Boolean },
    modelValue: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: "update:modelValue", value: IFieldValue): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message?: string, rules?: IFormRule[], lazy?: boolean, modelValue: IFieldValue };



// emit


// computed
const isValid = computed<boolean>(() => {
  return validate();
});
const lazyIsValid = computed<boolean>(() => {
  if (props.lazy && !initialized.value) {
    return true;
  }

  return isValid.value;
});
const getMessage = computed<string>(() => {
  if (props.lazy && !initialized.value) {
    return props.message || "";
  }

  return errorMessage.value || props.message || "";
});

// data
const initialized = ref<boolean>(false);
const errorMessage = ref<string>("");
const model = computed<IFieldValue>({
  get: () => props.modelValue,
  set: (v) => emit("update:modelValue", v),
});

// methods
function validate(): boolean {
  if (!props.rules) return true;

  for (const rule of props.rules) {
    const answer = rule(model.value);

    if (typeof answer === "string") {
      const msg = answer;

      errorMessage.value = msg;
    }
    if (answer !== true) {
      return false;
    }
  }

  errorMessage.value = "";
  return true;
}

// watch
watch(model, () => {
  initialized.value = true;
});

return { __sfc: true,props, emit, isValid, lazyIsValid, getMessage, initialized, errorMessage, model, validate }
}

})